import { create } from 'zustand';
import { NexoyaOptimizationStatus, NexoyaOptimizationTaskStatus, NexoyaOptimizationV2 } from '../types';

type OptimizationStore = {
  optimizations: NexoyaOptimizationV2[];
  setOptimizations: (optimizations: NexoyaOptimizationV2[]) => void;
  performanceChartOptimization: NexoyaOptimizationV2;
  setPerformanceChartOptimization: (optimization: NexoyaOptimizationV2) => void;

  activeOptimization: NexoyaOptimizationV2 | null;
  setActiveOptimization: (optimization: NexoyaOptimizationV2 | null) => void;
  isOptimizationRunning: () => boolean;
  resetOptimizations: () => void;
};

export const useOptimizationStore = create<OptimizationStore>((set, get) => ({
  optimizations: [],
  setOptimizations: (optimizations) => set({ optimizations }),

  performanceChartOptimization: null,
  setPerformanceChartOptimization: (optimization) => set({ performanceChartOptimization: optimization }),

  activeOptimization: null,
  setActiveOptimization: (activeOptimization) => set({ activeOptimization }),
  isOptimizationRunning: () => {
    const { activeOptimization } = get();
    if (!activeOptimization?.tasks) return false;
    return (
      activeOptimization.status === NexoyaOptimizationStatus.Running &&
      activeOptimization.tasks.PROPOSAL_WAITING !== NexoyaOptimizationTaskStatus.Running
    );
  },
  resetOptimizations: () =>
    set({
      optimizations: [],
      activeOptimization: null,
    }),
}));
